import React from 'react'

interface IPayCompleteProps {
  width?: string
  height?: string
}

const defaultProps: IPayCompleteProps = {
  width: '72',
  height: '72',
}

export const PayComplete: React.FC<IPayCompleteProps> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 17.7909 1.79086 16 4 16H52C54.2091 16 56 17.7909 56 20V68C56 70.2091 54.2091 72 52 72H4C1.79086 72 0 70.2091 0 68V20Z"
        fill="#6FC400"
      />
      <path
        d="M16 4C16 1.79086 17.7909 0 20 0H68C70.2091 0 72 1.79086 72 4V52C72 54.2091 70.2091 56 68 56H20C17.7909 56 16 54.2091 16 52V4Z"
        fill="#5BBBFC"
      />
      <path
        d="M56 56H20C17.7909 56 16 54.2091 16 52V16H52C54.2091 16 56 17.7909 56 20V56Z"
        fill="#FAF8F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.5833 24.4714C49.0129 24.8186 49.0797 25.4482 48.7325 25.8777L32.6683 45.7552C32.2923 46.2204 31.5947 46.2537 31.1762 45.8264L23.4497 37.939C23.0632 37.5444 23.0697 36.9113 23.4642 36.5248L24.5358 35.4752C24.9303 35.0887 25.5634 35.0952 25.9499 35.4897L30.9252 40.5687C31.3438 40.996 32.0413 40.9627 32.4173 40.4975L46.0104 23.6778C46.3575 23.2482 46.9871 23.1814 47.4167 23.5286L48.5833 24.4714Z"
        fill="#001C64"
      />
    </svg>
  )
}

PayComplete.defaultProps = defaultProps
